import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setOnlineQuoteForm } from 'routes/online_quotes/content/onlineQuoteFormSlice';
import { validatePhone, formatPhoneNumber } from 'utils/validatePhone';
import { validateZip, formatZipCode } from 'utils/validateZip';

const Segment1 = ({ showErrors = false }) => {


  // REDUX HANDLING
  const dispatch = useDispatch()
  const onlineQuoteForm = useSelector((state) => state.onlineQuoteForm.value)


  const [formData, setFormData] = useState({
    phone: '',
    gender: '',
    state: '',
    zipCode: '',

    insuranceRequirements: '',
    insuranceNeeds: '',
    idealConditions: '',
  });


  const handleInputChange = (e) => {
    let { name, value } = e.target;

    if (name === 'phone') {
      value = formatPhoneNumber(value);
    } else if (name === 'zipCode') {
      value = formatZipCode(value);
    }
    setFormData(prevState => ({ ...prevState, [name]: value }));
  };

  useEffect(() => {
    setFormData({
      phone: onlineQuoteForm.phone,
      gender: onlineQuoteForm.gender,
      state: onlineQuoteForm.state,
      zipCode: onlineQuoteForm.zipCode,

      // insuranceRequirements: onlineQuoteForm.insuranceRequirements,
      // insuranceNeeds: onlineQuoteForm.insuranceNeeds,
      // idealConditions: onlineQuoteForm.idealConditions,
    })
  }, []);

  useEffect(() => {
    dispatch(setOnlineQuoteForm(formData))
  }, [formData, dispatch]);

  const phoneEmpty = showErrors && !formData.phone?.trim();
  const phoneFormatInvalid = showErrors && Boolean(formData.phone?.trim()) && !validatePhone(formData.phone);
  const phoneInvalid = phoneEmpty || phoneFormatInvalid;
  const stateInvalid = showErrors && !formData.state;
  const zipFormatInvalid = showErrors && Boolean(formData.zipCode?.trim()) && !validateZip(formData.zipCode);
  const genderInvalid = showErrors && !formData.gender;

  return (
    <>

      <label className="form-control w-full px-2 py-1" data-invalid={phoneInvalid ? "true" : undefined}>
        <div className="label py-[1px]">
          <span className="label-text">Phone <span className="text-error">*</span></span>
          {phoneEmpty && <span className="text-[11px] font-bold text-white bg-red-600 px-1.5 py-0.5 rounded">Required</span>}
          {phoneFormatInvalid && <span className="text-[11px] font-bold text-white bg-red-600 px-1.5 py-0.5 rounded">Invalid 10-digit Phone</span>}
        </div>
        <input
          type="tel"
          placeholder="(XXX) XXX-XXXX"
          className={`input input-sm input-bordered w-full ${phoneInvalid ? 'input-error border-2 border-red-600 bg-red-50' : ''}`}
          name="phone"
          value={formData.phone}
          onChange={handleInputChange}
        />
      </label>


      <label className="form-control w-full px-2 py-1" data-invalid={stateInvalid ? "true" : undefined}>
        <div className="label py-[1px]">
          <span className="label-text">State <span className="text-error">*</span></span>
          {stateInvalid && <span className="text-[11px] font-bold text-white bg-red-600 px-1.5 py-0.5 rounded">Required</span>}
        </div>
        <select
          className={`select select-sm select-bordered w-full ${stateInvalid ? 'select-error border-2 border-red-600 bg-red-50' : ''}`}
          name="state"
          value={formData.state}
          onChange={handleInputChange}
        >
          <option disabled value="">Select State</option>
          <option value="Alabama">Alabama</option><option value="Alaska">Alaska</option><option value="Arizona">Arizona</option><option value="Arkansas">Arkansas</option><option value="California">California</option><option value="Colorado">Colorado</option><option value="Connecticut">Connecticut</option><option value="Delaware">Delaware</option><option value="Florida">Florida</option><option value="Georgia">Georgia</option><option value="Hawaii">Hawaii</option><option value="Idaho">Idaho</option><option value="Illinois">Illinois</option><option value="Indiana">Indiana</option><option value="Iowa">Iowa</option><option value="Kansas">Kansas</option><option value="Kentucky">Kentucky</option><option value="Louisiana">Louisiana</option><option value="Maine">Maine</option><option value="Massachusetts">Massachusetts</option><option value="Michigan">Michigan</option><option value="Minnesota">Minnesota</option><option value="Mississippi">Mississippi</option><option value="Missouri">Missouri</option><option value="Montana">Montana</option><option value="Nebraska">Nebraska</option><option value="Nevada">Nevada</option><option value="New Hampshire">New Hampshire</option><option value="New Jersey">New Jersey</option><option value="New Mexico">New Mexico</option><option value="New York">New York</option><option value="North Carolina">North Carolina</option><option value="North Dakota">North Dakota</option><option value="Ohio">Ohio</option><option value="Oklahoma">Oklahoma</option><option value="Oregon">Oregon</option><option value="Pennsylvania">Pennsylvania</option><option value="Rhode Island">Rhode Island</option><option value="South Carolina">South Carolina</option><option value="South Dakota">South Dakota</option><option value="Tennessee">Tennessee</option><option value="Texas">Texas</option><option value="Utah">Utah</option><option value="Vermont">Vermont</option><option value="Virginia">Virginia</option><option value="Washington">Washington</option><option value="West Virginia">West Virginia</option><option value="Wisconsin">Wisconsin</option><option value="Wyoming">Wyoming</option>
        </select>
      </label>


      <label className="form-control w-full px-2 py-1" data-invalid={zipFormatInvalid ? "true" : undefined}>
        <div className="label py-[1px]">
          <span className="label-text">Zip Code</span>
          {zipFormatInvalid && <span className="text-[11px] font-bold text-white bg-red-600 px-1.5 py-0.5 rounded">Invalid 5-digit ZIP</span>}
        </div>
        <input
          type="text"
          inputMode="numeric"
          maxLength={5}
          placeholder="5-digit ZIP code"
          className={`input input-sm input-bordered w-full ${zipFormatInvalid ? 'input-error border-2 border-red-600 bg-red-50' : ''}`}
          name="zipCode"
          value={formData.zipCode}
          onChange={handleInputChange}
        />
      </label>

      <label className="form-control w-full px-2 py-1" data-invalid={genderInvalid ? "true" : undefined}>
        <div className="label py-[1px]">
          <span className="label-text">Gender <span className="text-error">*</span></span>
          {genderInvalid && <span className="text-[11px] font-bold text-white bg-red-600 px-1.5 py-0.5 rounded">Required</span>}
        </div>
        <select
          className={`select select-sm select-bordered w-full ${genderInvalid ? 'select-error border-2 border-red-600 bg-red-50' : ''}`}
          name="gender"
          value={formData.gender}
          onChange={handleInputChange}
        >
          <option disabled value="">Select</option>
          <option value="Male">Male</option>
          <option value="Female">Female</option>
        </select>
      </label>




      {/* THIS QUESTIONS ARE FOR GROUP CENSUS FORM */}
      {/* 
      <br />

      <label className="form-control w-full px-2 py-1">
        <div className="label py-[1px]">
          <span className="label-text">What matters most for your requirements regarding health insurance?</span>
        </div>
        <select
          required
          className="select select-sm select-bordered w-full"
          name="insuranceRequirements"
          value={formData.insuranceRequirements}
          onChange={handleInputChange}
        >
          <option disabled value="">Select</option>
          <option value="Premium Cost">Premium Cost</option>
          <option value="ACA Compliance">ACA Compliance</option>
          <option value="Coverage/Benefits">Coverage/Benefits</option>
          <option value="Other">Other</option>
        </select>
      </label>


      <label className="form-control w-full px-2 py-1">
        <div className="label py-[1px]">
          <span className="label-text">Which best identifies your
            current health insurance needs?</span>
        </div>
        <select
          required
          className="select select-sm select-bordered w-full"
          name="insuranceNeeds"
          value={formData.insuranceNeeds}
          onChange={handleInputChange}
        >
          <option disabled value="">Select</option>
          <option value="Shopping around">Shopping around</option>
          <option value="Unhappy w/ current provider">Unhappy w/ current provider</option>
          <option value="Ready To Purchase">Ready To Purchase</option>
        </select>
      </label>


      <label className="form-control w-full px-2 py-1">
        <div className="label py-[1px]">
          <span className="label-text">Please describe the ideal conditions you are looking for
            when purchasing health insurance</span>
        </div>
        <textarea
          className="textarea textarea-bordered"
          placeholder="Write it here..."
          name="idealConditions"
          value={formData.idealConditions}
          onChange={handleInputChange}
        />
      </label> */}

    </>
  );
}

export default Segment1;
